
export default class PolicyGridModel {
    dateAdded: Date
    insuranceId: String
    fullName: String
    aircraftRegistrationMark: String
    status: String
    liabilityLimit: Number
    passengersLiabilityLimit: Number
    airCrewLiabilityLimit: Number
    firstGuidance: Boolean
    email: String
    policyNumber: Number
    finalPrice: Number
    liabilityLimitPremium: Number
    passengersLiabilityLimitPremium: Number
    airCrewLiabilityLimitPremium: Number
    validFromUtc: Date
}

